module.exports = {
  Base: Backbone.Collection.extend({})
};



// WEBPACK FOOTER //
// ./webroot/js/collection.js